export default __webpack_public_path__ + "static/media/Full.31ecc6d3.svg";